import http from '@/utils/http';

/**
 * 获取商品详细信息
 * @param {*} spuId
 */
export function getSpuDetail(spuId) {
  return http.get("/xlb/spu/detail", {
    spuId: spuId
  });
}


// WEBPACK FOOTER //
// ./src/api/spu.js